import gitInfo from '../git'

export function request(options = {}, context = {}) {
  const { project } = context
  const { cwd = project.realCwd } = options

  return Promise.resolve(
    gitInfo(projectPath)
  )
}

export default request


// WEBPACK FOOTER //
// ./src/data-sources/git-stats.js